export const downloadPdfFromBase64 = (labelContent: any, fileName: string) => {
    const bString = window.atob(labelContent);
    const bytes = new Uint8Array(bString.length);

    for (let i = 0; i < bString.length; i++) {
        bytes[i] = bString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    document.body.appendChild(link);

    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
    link.remove();
};